import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { intl } from "LocaleWrapper";
import { VolumeUnit } from "__generated__/enums";

type VolumeUnitSelectProps = Omit<SelectProps<VolumeUnit, false>, "fetchOptions">;

const VolumeUnitSelect = ({ value, onChange, disabled, clearable }: VolumeUnitSelectProps) => {
	return (
		<Select
			fetchOptions={Object.values(VolumeUnit)}
			getOptionLabel={option => intl.formatMessage({ id: intl.formatMessage({ id: `UNIT_${option}` }) })}
			value={value}
			disabled={disabled}
			onChange={onChange}
			clearable={clearable}
			disableSearch
		/>
	);
};

export default VolumeUnitSelect;
